"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrendingSearch = exports.trendingSearchSchema = void 0;
var yup = require("yup");
var ScheduledItem_1 = require("./ScheduledItem");
exports.trendingSearchSchema = ScheduledItem_1.scheduledItemSchema.shape({
    query: yup.string(),
});
function isTrendingSearch(obj) {
    return exports.trendingSearchSchema.isValidSync(obj);
}
exports.isTrendingSearch = isTrendingSearch;
